import React from "react";

function Menu() {
  return (
    <div className="footer__menu">
      <div className="menu">
        <ul>
          <li>vision</li>
          <li>blog</li>
          <li>about us</li>
          <li>contact</li>
          <li>terms</li>
          <li>privacy</li>
          <li>purchasing</li>
        </ul>
      </div>
      <div className="contacts">
        <ul>
          <li>Phone:</li>
          <li>416.423.7906</li>
          <li>Email:</li>
          <li>Info@Myant.Ca</li>
          <li>Media/PR:</li>
          <li>Pr@Myant.Ca</li>
        </ul>
      </div>
    </div>
  );
}

export default Menu;
